export default "__VITE_ASSET__BloU$zqx__"